import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { FindHttpError } from '../error/find-http-error';

@Injectable()
export class JiraIssueInfoService {
  private TEST_RESULT_END_POINT = '/jira/test-results';
  private ISSUE_TYPE_END_POINT = '/jira/issue-types';
  private STORAGE_STATUS_END_POINT = '/jira/storage-status';
  private RESCHEDULE_REASONS_END_POINT = '/jira/reschedule-reasons';
  private FAILURE_CATEGORY_END_POINT ='/jira/failure-category'
  private FAILURE_CAUSE_BY_CATEGORY_END_POINT ='/jira/failure-cause-by-category'
  _httpService: HttpService;


  constructor(private httpService: HttpService) {
    this._httpService = httpService;
  }

  getTestResults() {
    return this._httpService.get(`${this.TEST_RESULT_END_POINT}/`, Array, FindHttpError);
  }

  getIssueTypes() {
    return this._httpService.get(`${this.ISSUE_TYPE_END_POINT}/`, Array, FindHttpError);
  }

  getStorageStatus() {
    return this._httpService.get(`${this.STORAGE_STATUS_END_POINT}/`, Array, FindHttpError);
  }

  getRescheduleReasons() {
    return this._httpService.get(`${this.RESCHEDULE_REASONS_END_POINT}/`, Array, FindHttpError);
  }
  getFailureCategory() {
    return this._httpService.get(`${this.FAILURE_CATEGORY_END_POINT}/`, Array, FindHttpError);
  }
  getFailureCauseByCategory(failureCategory) {
    return this._httpService.get(`${this.FAILURE_CAUSE_BY_CATEGORY_END_POINT}?failureCategory=${failureCategory}`, Array, FindHttpError);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/jira-info-service.ts